import React from "react";
import { useParams } from "react-router-dom";
import { apiClient } from "src/api/apiService";
import {
  initialValues,
  mapDraftServiceToFormikValues,
  RemoveSupplyFormValues,
} from "src/components/Form/RemoveSupply";
import { getFormattedAddress, PremiseDetails } from "src/components/Premises";
import RemoveSupplyContext from "src/context/RemoveSupplyContext";

export const useRemoveSupplyEffect = () => {
  const [formValues, setFormValues] =
    React.useState<RemoveSupplyFormValues>(initialValues);
  const [isLoading, setIsLoading] = React.useState(false);
  const { setDraftInfo, setPremiseAddress } =
    React.useContext(RemoveSupplyContext);

  const { requestId } = useParams<{ requestId: string }>();

  React.useEffect(() => {
    const getDraftDetails = async () => {
      setIsLoading(true);
      try {
        const { data } = await apiClient.get(`/draft/request/${requestId}`);

        setFormValues(mapDraftServiceToFormikValues(data));

        // Set metadata in context
        setDraftInfo({
          draft_id: data.services[0].draft_id ?? "",
          draft_version: data.services[0].draft_version ?? "",
          request_id: data.services[0].request_id ?? "",
          raw_request_status: data.services[0].raw_request_status ?? "",
          request_type: data.services[0].request_type ?? "",
          message_enabled: data.services[0].message_enabled ?? false,
        });

        // Set premise address in context
        setPremiseAddress(
          data.premise
            ? getFormattedAddress(data.premise as PremiseDetails)
            : null
        );
      } catch (error) {
        console.error("Error fetching draft details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (requestId) {
      getDraftDetails();
    }
  }, [requestId, setDraftInfo, setPremiseAddress]);

  return { isLoading, formValues };
};
